"use strict";
var FromEventObservable_1 = require("./FromEventObservable");
exports.fromEvent = FromEventObservable_1.FromEventObservable.create;
//# sourceMappingURL=fromEvent.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/observable/fromEvent.js
 ** module id = 209
 ** module chunks = 1
 **/